<div class="container-fluid">
	<div class="col-md-12" *ngIf="isLoading">
		<app-busy [message]="message"></app-busy>
	</div>
	
	<div class="page_header">
		<h1 class="heading">Manage Workflow Status</h1>
	</div>

	<app-filter></app-filter>
	<ng-template #content let-modal>
		<div class="modal-header">
			<h4 class="modal-title" id="modal-basic-title"> Delete Confirmation</h4>
			<button type="button" class="btn-close" aria-label="Close"
				(click)="modal.dismiss('Cross click')">&times;</button>
		</div>
		<div class="modal-body">
			<input type="hidden" [(ngModel)]="removeRef" name="id" /> <span [innerHTML]="deleteConfirm"></span>
		</div>
		<div class="modal-footer">
			<button class="btn btn-danger btn-sm" (click)="onDelete(removeRef.id)" style="width:80px;">Yes</button>
			<button class="btn btn-default btn-sm" (click)="modal.dismiss('Cross click')"
				style="width:80px;">No</button>
		</div>
	</ng-template>

	<div class="row">
		<div class="col-md-12">
			<!-- Table Actions -->
			<app-actions [actions]="wfStatusTypeActions" (actionEvent)="doPermitAction($event)"></app-actions>

			<!-- End Table Actions -->

			<div class="table-responsive">
				<table class="table table-sm custom_table">
					<thead class="thead-inverse">
						<tr class="hdclpse">
							<th>Select</th>
							<th class="bfr-end-col">Code</th>
                            <th class="bfr-end-col">Status</th>
							<th class="bfr-end-col">Description</th>							
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let status of statuses ">
							<td><input type="checkbox" value="{{item}}" (change)="onChecked($event,status)"></td>
							<td class="bfr-end-col">{{status.code}}</td>
                            <td class="bfr-end-col">{{status.status}}</td>
							<td class="bfr-end-col">{{status.description}}</td>
						</tr>
					</tbody>
					<tfoot>
						<tr *ngIf="statuses.length==0">
							<td colspan="8" class="rm-brd text-center">
								<span class="text-info text-small">No workflow status found.</span>
							</td>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
	</div>


        <!-- BEGIN POPUP-->
        <button data-toggle="modal" data-target="#addEdit" id="popupButton" style="display:none"></button>
        <div class="modal fade form-group" id="addEdit" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <label class="text-center title">{{this.lblHeading}}</label>
                        <button type="button" class="close" data-dismiss="modal" id="closeButton" #closebutton aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body modal-lg">
                            <div class="row">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-6">
                                            <label class="form-label">Status *</label>
                                            <input class="form-control form-control-sm" type="text" [(ngModel)]="statusdto.status"/>
                                        </div>
                                        <div class="col-6">
                                            <label class="form-label">Code *</label>
                                            <input class="form-control form-control-sm" type="text" [(ngModel)]="statusdto.code"/>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-12">
                                            <label class="form-label">Description</label>
                                            <textarea class="form-control form-control-sm" rows="3" [(ngModel)]="statusdto.description"></textarea>
                                        </div>
                                    </div>
                                    <br>
                                </div>
                            </div>
                            <div class="modal-footer">    
                                <div class="d-grid gap-2 d-sm-flex justify-content-sm-end">
                                    <button class="btn btn-sm btn-primary" type="button" style="width: 100px !important;" [disabled]="this.statusdto.status==undefined || this.statusdto.code==undefined" *ngIf="mode=='Add'" (click)="onAdd()">Add</button>
                                    <button class="btn btn-sm btn-primary" type="button" style="width: 100px !important;" [disabled]="this.statusdto.status==undefined || this.statusdto.code==undefined" *ngIf="mode=='Edit'" (click)="onUpdate()">Save</button>
                                </div>
                            </div>
                    </div>
                </div>        
            </div>
        </div>
        
            <!-- END POPUP-->
</div>